import { _ as a, L as r } from "../../../dummyModel-DGc8qBEQ.js";
const d = (e) => {
  switch (e.predicate.operator) {
    case a.EQ:
    case a.GTE:
    case a.GT:
    case a.LT:
    case a.LTE:
      return {
        predicate: e.predicate,
        metricCode: e.reference.code,
        type: r.metric,
        reference: e.reference,
        isValid: e.isValid,
        dataType: e.dataType
      };
    case a.BETWEEN:
      return {
        predicate: e.predicate,
        metricCode: e.reference.code,
        type: r.metric,
        reference: e.reference,
        isValid: e.isValid,
        dataType: e.dataType
      };
    default:
      return;
  }
};
export {
  d as consolidateUniversalConfFilterToMetric
};
//# sourceMappingURL=MetricFilterSelector.utils.js.map
